import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showMessageAction } from 'store/global/actions';

import { SECTION_VALIDATORS } from './config';

export const useSectionValidation = ({
  titleCompany,
  escrowCompany,
  sellerAttorney,
  buyerAttorney,
  isTrustSectionVisible,
}) => {
  const dispatch = useDispatch();

  const validateSections = useCallback(
    (allFormData, visitedSections) => {
      const context = {
        titleCompany,
        escrowCompany,
        sellerAttorney,
        buyerAttorney,
        isTrustSectionVisible,
      };

      const failedError = Object.entries(SECTION_VALIDATORS).reduce((acc, [section, validator]) => {
        if (acc || !visitedSections.has(section)) {
          return acc;
        }

        return validator(allFormData, context) || acc;
      }, null);

      if (failedError) {
        dispatch(showMessageAction(failedError));

        return false;
      }

      return true;
    },
    [titleCompany, escrowCompany, sellerAttorney, buyerAttorney, isTrustSectionVisible, dispatch],
  );

  return { validateSections };
};
